import request from '@/utils/request'

export function updateCommonCfg(data) {
  return request({
    url: 'api/v1/common/updateCfg',
    method: 'post',
    data: data
  })
}

export function getCommonCfg(data) {
  return request({
    url: 'api/v1/common/getCfg',
    method: 'post',
    data: data
  })
}

export function exportStealRatic(data) {
  return request({
    url: 'api/v1/common/exportStealRatic',
    method: 'get'
  })
}

export function importStealRatic(data) {
  return request({
    url: 'api/v1/common/importStealRatic',
    method: 'post',
    data: data
  })
}

export function uploadCdn(data) {
  return request({
    url: 'api/v1/common/updateCdn',
    method: 'post',
    data: data
  })
}

export function getBetConfig(data) {
  return request({
    url: 'api/v1/common/getBetCfg',
    method: 'post',
    data: data
  })
}

export function resetBotList(data) {
  return request({
    url: 'api/v1/common/resetBotCfg',
    method: 'post',
    data: data
  })
}
